module.exports = __webpack_public_path__ + "media/images/prizes/banner_bg_mb-880a5634c85130fb4613e91c70333b75.png";